<sd-border-wrapper [hasBorder]="false" class="has-no-padding" data-testid="wrapper">
  @if (addresses?.length > 0) {
    <div class="c__content-wrapper">
      @for (address of addresses; track address) {
        <sd-address-card [title]="address?.title | translate"
          [titleLevel]="titleLevel"
          [readOnly]="readOnly || address?.readonly"
          [inactive]="inactive || address?.inactive"
          [showMainAddress]="false"
          [pickupRepairChooseAction]="pickupRepairChooseAction"
          (edit)="editAddress(address, $index)"
          (switch)="otherAddress(address, $index)"
          [address]="address"
          data-testid="card"
        />
      }
    </div>
  }

  @if (hasSubContent) {
    <div class="c__dynamic-content" data-testid="content">
      <ng-content />
    </div>
  }
</sd-border-wrapper>
